<template>
  <div class="ui-icon">
    <svg
      v-if="name === 'eye'"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      v-if="name === 'eye-cross'"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
      />
    </svg>
    <svg
      v-if="name === 'settings'"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
      />
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
    <svg
      v-if="name === 'inbox'"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      v-if="name === 'trash'"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      v-if="name === 'spam'"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      v-if="name === 'back'"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M10 19l-7-7m0 0l7-7m-7 7h18"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      v-if="name === 'edit'"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      v-if="name === 'arrow-down'"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 9l-7 7-7-7"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      v-if="name === 'arrow-right'"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M9 5l7 7-7 7"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      v-if="name === 'close'"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      v-if="name === 'plus'"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
      <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          v-if="name === 'print'"
      >
          <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M 22.667969 10.351562 L 21.332031 10.351562 L 21.332031 0.984375 C 21.332031 0.613281 21.035156 0.316406 20.667969 0.316406 L 3.332031 0.316406 C 2.964844 0.316406 2.667969 0.613281 2.667969 0.984375 L 2.667969 10.351562 L 1.332031 10.351562 C 0.597656 10.351562 0 10.945312 0 11.683594 L 0 22.351562 C 0 23.085938 0.597656 23.683594 1.332031 23.683594 L 22.667969 23.683594 C 23.402344 23.683594 24 23.085938 24 22.351562 L 24 11.683594 C 24 10.945312 23.402344 10.351562 22.667969 10.351562 Z M 17.351562 20.316406 L 6.648438 20.316406 L 6.648438 17.648438 L 17.351562 17.648438 Z M 20 10.351562 L 18.667969 10.351562 C 17.929688 10.351562 17.332031 10.949219 17.332031 11.683594 L 17.332031 14.351562 L 6.667969 14.351562 L 6.667969 11.683594 C 6.667969 10.949219 6.070312 10.351562 5.332031 10.351562 L 4 10.351562 L 4 1.648438 L 20 1.648438 Z M 17.332031 4.6875 L 6.667969 4.6875 C 6.296875 4.6875 6 4.390625 6 4.023438 C 6 3.65625 6.296875 3.355469 6.667969 3.355469 L 17.332031 3.355469 C 17.699219 3.355469 18 3.65625 18 4.023438 C 18 4.390625 17.699219 4.6875 17.332031 4.6875 Z M 17.332031 7.355469 L 6.667969 7.355469 C 6.296875 7.355469 6 7.058594 6 6.6875 C 6 6.320312 6.296875 6.023438 6.667969 6.023438 L 17.332031 6.023438 C 17.699219 6.023438 18 6.320312 18 6.6875 C 18 7.058594 17.699219 7.355469 17.332031 7.355469 Z M 17.332031 10.023438 L 6.667969 10.023438 C 6.296875 10.023438 6 9.722656 6 9.355469 C 6 8.988281 6.296875 8.6875 6.667969 8.6875 L 17.332031 8.6875 C 17.699219 8.6875 18 8.988281 18 9.355469 C 18 9.722656 17.699219 10.023438 17.332031 10.023438 Z M 17.332031 10.023438"
          />
      </svg>
  </div>
</template>

<script>
export default {
  name: 'ui-icon',
  props: {
    name: String
  }
}
</script>

<style>
.ui-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.ui-icon svg {
  width: 1em;
}
</style>
